module.exports = __webpack_public_path__ + "static/ead-02-ff027e9a13eaacc221d9960f61344073.png";